import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('access_token');

  // Проверяем только наличие токена. Истечение/права валидируются бэкендом (401 → редирект).
  if (!token) {
    // Очистим возможный мусор, чтобы не было ложного UI
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  return children;
};

export default ProtectedRoute; 